import Cookies from 'js-cookie';
import { getCountryCodeFromTLD } from './country';

const LEAD_INFO_COOKIE = 'leadInfo';

export const replaceDomain = (domain: string) => {
  // Are we on a connect domain? If yes, we force the onetrust consent to run for the equivalent www domain
  if (domain.includes('connect')) {
    domain = domain.replace('connect', 'www');
  }
  return domain;
};

export const loadTreatwellCookieConsent = () => {
  // Are we on a connect domain? If yes, we force the onetrust consent to run for the equivalent www domain
  const domain = replaceDomain(window.location.hostname);
  const contryCodeFromTLD = getCountryCodeFromTLD();

  // Load onetrust script
  const script = document.createElement('script');
  script.src = 'https://cdn1.treatwell.net/cookie-consent/TwCookieConsent.js';
  // Surface real error details to Datadog instead of an opaque
  // cross-origin "Script error." (cdn1.treatwell.net sends Access-Control-Allow-Origin).
  script.crossOrigin = 'anonymous';
  script.setAttribute('data-initialise', 'false');
  script.onload = () => {
    if (contryCodeFromTLD === 'GR') {
      window.TreatwellCookieConsent?.({ forceDomain: domain });
    } else {
      window.TreatwellCookieConsent?.();
    }
  };
  document.head.appendChild(script);
};

export type LeadInfo = {
  salon_name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  leadId?: string;
};

export const getLeadInfoCookie = (): LeadInfo | null => {
  const cookie = Cookies.get(LEAD_INFO_COOKIE);
  if (!cookie) {
    return null;
  }
  try {
    return JSON.parse(cookie) as LeadInfo;
  } catch (e) {
    return null;
  }
};

export const deleteLeadInfoCookie = () => {
  Cookies.remove(LEAD_INFO_COOKIE);
};
